import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'
  import { fileUtils } from '../util/file.utils'
  
  export class FotosService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia)
      this.url = env.baseIdentificacao + "fotos/";
    }

    async adquirirFotoPorID(id, tamanho = {w: 100, h: 100}, objetoDeFiltros = {}) {
        const filtros = {
            ...tamanho,
            ...objetoDeFiltros
        }

        const queryString = this.converterObjetoDeFiltrosParaQueryString(filtros);
        
        const foto = await this.getFile(`${this.url}${id}${queryString}`);

        if(foto instanceof Blob) {
          const base64 = await fileUtils.converterBlobParaBase64(foto);
          return base64;
        };

        throw new Error("Formato do request não esperado");
    }
  }
  
  export const fotosService = new FotosService()
  